/**
 * 为了实现动态载入reducer，加入这个组件
 */
import { combineReducers } from 'redux';

var reducerStore = {}

export default {
    add(key, reducer) {
        if (typeof reducer != 'function') {
            throw new Error('reducerStore:reducer must be a function');
        }
        reducerStore[key] = reducer;
        return combineReducers(reducerStore);
    },
    remove(key) {
        if(reducerStore[key]){
            delete reducerStore[key];
        }
        return combineReducers(reducerStore);
    }
}


// WEBPACK FOOTER //
// ./_source/cqsx/services/reducer-store.js